import { Button } from '@/components/form/Button';
import { useControls } from '@/components/multistep/useMultistep';
import { FunctionComponent, useState } from 'react';

interface CompanyOnboardingQuestionnaireTAndCControlsProps {}

const CompanyOnboardingQuestionnaireTAndCControls: FunctionComponent<
  CompanyOnboardingQuestionnaireTAndCControlsProps
> = () => {
  const { skipToStep, finish } = useControls();

  const [loading, setLoading] = useState(false);

  const onFinish = async () => {
    setLoading(true);
    await finish();
    setLoading(false);
  };

  return (
    <div>
      <div className="mt-6 flex justify-between">
        <Button onClick={() => skipToStep('business-details')}>Previous</Button>
        <Button loading={loading} onClick={onFinish}>
          Go To Docusign
        </Button>
      </div>
    </div>
  );
};

export default CompanyOnboardingQuestionnaireTAndCControls;
